import { defineMessages, type IntlShape } from 'react-intl';
import type { JSONSchema } from '@plone/types';
import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';

const addShowAsCard = ({
  schema,
  formData,
  intl,
}: {
  schema: JSONSchema;
  formData: JSONSchema;
  intl: IntlShape;
}): JSONSchema => {
  addStyling({ schema, intl, formData });

  // @ts-expect-error
  schema.properties.styles.schema.fieldsets[0].fields = [
    // @ts-expect-error
    ...schema.properties.styles.schema.fieldsets[0].fields,
    'show_as_card',
  ];
  // @ts-expect-error
  schema.properties.styles.schema.properties['show_as_card'] = {
    type: 'boolean',
    title: intl.formatMessage(messages.show_as_card_title),
  };

  return schema;
};

export default addShowAsCard;
const messages = defineMessages({
  show_as_card_title: {
    id: 'show_as_card_title',
    defaultMessage: 'Show as card',
  },
});
